/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {useState, useEffect} from 'react';
import LoadingIcon from 'icons/LoadingIcon';
import './ContentLoading.css';

const ContentLoading = ({delayMs = 250}) => {
  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setHidden(false);
    }, delayMs);
    return () => {
      clearTimeout(timer);
    };
  }, [delayMs]);

  return (
    <div
      className={`my-4 d-flex justify-content-center ContentLoading ${
        hidden ? 'hidden' : ''
      }`}
    >
      <LoadingIcon size="5x" />
    </div>
  );
};

export default ContentLoading;
